
<mat-progress-bar 
	*ngIf="(status$ | push) === 'pending'" 
	[@fadeIfAnimation]
	mode="indeterminate"
></mat-progress-bar>
